module.exports = __webpack_public_path__ + "static/media/smallLogo.79a706b7.png";